import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BasketItem } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-basket-taxi',
  templateUrl: './basket-taxi.component.html',
  styleUrls: ['./basket-taxi.component.scss'],
  standalone: false
})
export class BasketTaxiComponent implements OnInit {
  @Input() taxi: BasketItem;
  @Input() duplicateBooking = false;
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChangeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() displayItinerary = false;

  travellers = [];

  constructor() {}

  ngOnInit(): void {
    this.travellers = [...(this.taxi?.users || []), ...(this.taxi?.guests || [])];
  }
}
